import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header.js";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import Backdrop from "@mui/material/Backdrop";
import AlertMessage from "../../common/components/AlertMessage.js";
import * as APIService from "../../common/api/index.js";
import URL from "../../common/api/ConstantURL.js";
import { getSessionContext } from "../../common/utils/sessionContext";
import * as Sentry from "@sentry/react";
import "../../styles/additionalrequest.css";

const AdditionalRequestPage = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [statusId, setStatusId] = useState(0);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [alertStatus, setAlertStatus] = useState("");

  const handleBack = () => navigate(-1);
  const closeAlert = () => setAlertStatus("");

  const handleSave = async () => {
    try {
      const { residentId, caregiverId, shiftId, communityId } = getSessionContext();
      const clientId = residentId;
      if (!title.trim() && !description.trim()) {
        setAlertStatus({
          message: "Please enter at least a title or description.",
          status: "400",
          origin: "center",
        });
        return;
      }
      const normalize = (val = "") => val.replace(/^\s+|\s+$/g, "").replace(/\s+/g, " ");
      const payload = {
        clientId: Number(clientId) || null,
        title: title.trim(),
        description: description.trim(),
        reason: statusId === 3 ? normalize(reason) : "",
        acknowledgeFlag: statusId,
        caregiverId: Number(caregiverId) || null,
        shiftId: Number(shiftId) || null,
        communityId: Number(communityId) || null,
      };

      setLoading(true);

      const responseData = await APIService.postJsonData(URL.saveAdditionalTasks, payload);
      const isSuccess = responseData?.status === "success" || String(responseData?.code) === "200";
      if (!isSuccess) {
        setAlertStatus({
          message: responseData?.message || responseData?.msg || "Could not save request.",
          status: String(responseData?.code ?? "400"),
          origin: "center",
        });
        return;
      }
      setTitle("");
      setDescription("");
      setReason("");
      setStatusId(0);
      setAlertStatus({
        message: "Request saved successfully.",
        status: "200",
        origin: "center",
      });
    } catch (error) {
      Sentry.captureException(error);
      setAlertStatus({
        message: "Network error while saving request.",
        status: "400",
        origin: "center",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Backdrop sx={{ color: "#ffba30", zIndex: (theme) => theme.zIndex.drawer + 1000 }} open={loading}>
        <img src={require("../../assets/btTree.png")} className="loading-img" alt="" />
      </Backdrop>

      {alertStatus && <AlertMessage status={alertStatus.status} message={alertStatus.message} origin={alertStatus.origin} closeAlert={closeAlert} />}

      <div className="home-container addreq-home-container">
        <div className="home-inner-container resident-task-layout addreq-inner">
          <div className="heading vitals-heading addreq-page-header">
            <IoChevronBackCircleSharp className="vitals-preview-header" onClick={handleBack} />
            <span>Additional Client Request</span>
            <span></span>
          </div>

          <div className="task-container overflowAuto col-11 col-sm-11 col-md-8 col-lg-4 col-xl-4 addreq-scroll">
            <div className="addreq-field">
              <label className="addreq-label">Client Name</label>
              <input type="text" className="addreq-input addreq-input--readonly" value={getSessionContext().residentName} readOnly tabIndex={-1} />
            </div>

            <div className="addreq-field">
              <label className="addreq-label">Title</label>
              <input type="text" className="addreq-input" value={title} placeholder="Add short title about the request..." onChange={(e) => setTitle(e.target.value.replace(/^\s+/, ""))} />
            </div>

            <div className="addreq-field">
              <label className="addreq-label">Description</label>
              <textarea className="addreq-input" value={description} placeholder="Add details about the request..." rows={3} onChange={(e) => setDescription(e.target.value.replace(/^\s+/, ""))} />
            </div>

            <div className="addreq-field" style={{ marginBottom: 16 }}>
              <label className="addreq-label">Status</label>
              <div className="addreq-status-row">
                <label>
                  <input type="radio" value={0} checked={statusId === 0} onChange={() => setStatusId(0)} /> TO DO
                </label>
                <label>
                  <input type="radio" value={1} checked={statusId === 1} onChange={() => setStatusId(1)} /> Completed
                </label>
                <label>
                  <input type="radio" value={3} checked={statusId === 3} onChange={() => setStatusId(3)} /> Declined
                </label>
              </div>
            </div>

            {statusId === 3 ? (
              <div className="addreq-field" style={{ marginBottom: 16 }}>
                <label className="addreq-label">Reason (Optional)</label>
                <textarea
                  className="addreq-input"
                  rows={3}
                  placeholder="Enter reason (optional)..."
                  value={reason}
                  onChange={(e) => {
                    const next = e.target.value.replace(/^\s+/, "");
                    setReason(next);
                  }}
                />
              </div>
            ) : null}

            <div className="addreq-save-wrap">
              <button type="button" className="addreq-save-btn" onClick={handleSave} disabled={loading || (!title.trim() && !description.trim())}>
                {loading ? "Saving..." : "Save Request"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdditionalRequestPage;
